/**
 * Soniox real-time speech-to-text + translation languages (any pair translates). Soniox TTS speaks
 * all of them, so every language gets translated captions and translated voice.
 */
export const LANGUAGES = [
  { code: "en", label: "English", native: "English", flag: "🇬🇧" },
  { code: "es", label: "Spanish", native: "Español", flag: "🇪🇸" },
  { code: "fr", label: "French", native: "Français", flag: "🇫🇷" },
  { code: "de", label: "German", native: "Deutsch", flag: "🇩🇪" },
  { code: "pt", label: "Portuguese", native: "Português", flag: "🇧🇷" },
  { code: "it", label: "Italian", native: "Italiano", flag: "🇮🇹" },
  { code: "zh", label: "Chinese", native: "中文", flag: "🇨🇳" },
  { code: "hi", label: "Hindi", native: "हिन्दी", flag: "🇮🇳" },
  { code: "ar", label: "Arabic", native: "العربية", flag: "🇸🇦" },
  { code: "ja", label: "Japanese", native: "日本語", flag: "🇯🇵" },
  { code: "ko", label: "Korean", native: "한국어", flag: "🇰🇷" },
  { code: "ru", label: "Russian", native: "Русский", flag: "🇷🇺" },
  { code: "nl", label: "Dutch", native: "Nederlands", flag: "🇳🇱" },
  { code: "tr", label: "Turkish", native: "Türkçe", flag: "🇹🇷" },
  { code: "pl", label: "Polish", native: "Polski", flag: "🇵🇱" },
  { code: "id", label: "Indonesian", native: "Bahasa Indonesia", flag: "🇮🇩" },
  { code: "vi", label: "Vietnamese", native: "Tiếng Việt", flag: "🇻🇳" },
  { code: "th", label: "Thai", native: "ภาษาไทย", flag: "🇹🇭" },
  { code: "bn", label: "Bengali", native: "বাংলা", flag: "🇧🇩" },
  { code: "ur", label: "Urdu", native: "اردو", flag: "🇵🇰" },
  { code: "fa", label: "Persian", native: "فارسی", flag: "🇮🇷" },
  { code: "uk", label: "Ukrainian", native: "Українська", flag: "🇺🇦" },
  { code: "sv", label: "Swedish", native: "Svenska", flag: "🇸🇪" },
  { code: "tl", label: "Tagalog", native: "Tagalog", flag: "🇵🇭" },
  { code: "af", label: "Afrikaans", native: "Afrikaans", flag: "🇿🇦" },
  { code: "sq", label: "Albanian", native: "Shqip", flag: "🇦🇱" },
  { code: "az", label: "Azerbaijani", native: "Azərbaycanca", flag: "🇦🇿" },
  { code: "eu", label: "Basque", native: "Euskara", flag: "🌐" },
  { code: "be", label: "Belarusian", native: "Беларуская", flag: "🇧🇾" },
  { code: "bs", label: "Bosnian", native: "Bosanski", flag: "🇧🇦" },
  { code: "bg", label: "Bulgarian", native: "Български", flag: "🇧🇬" },
  { code: "ca", label: "Catalan", native: "Català", flag: "🌐" },
  { code: "hr", label: "Croatian", native: "Hrvatski", flag: "🇭🇷" },
  { code: "cs", label: "Czech", native: "Čeština", flag: "🇨🇿" },
  { code: "da", label: "Danish", native: "Dansk", flag: "🇩🇰" },
  { code: "et", label: "Estonian", native: "Eesti", flag: "🇪🇪" },
  { code: "fi", label: "Finnish", native: "Suomi", flag: "🇫🇮" },
  { code: "gl", label: "Galician", native: "Galego", flag: "🌐" },
  { code: "el", label: "Greek", native: "Ελληνικά", flag: "🇬🇷" },
  { code: "gu", label: "Gujarati", native: "ગુજરાતી", flag: "🇮🇳" },
  { code: "he", label: "Hebrew", native: "עברית", flag: "🇮🇱" },
  { code: "hu", label: "Hungarian", native: "Magyar", flag: "🇭🇺" },
  { code: "kn", label: "Kannada", native: "ಕನ್ನಡ", flag: "🇮🇳" },
  { code: "kk", label: "Kazakh", native: "Қазақ тілі", flag: "🇰🇿" },
  { code: "lv", label: "Latvian", native: "Latviešu", flag: "🇱🇻" },
  { code: "lt", label: "Lithuanian", native: "Lietuvių", flag: "🇱🇹" },
  { code: "mk", label: "Macedonian", native: "Македонски", flag: "🇲🇰" },
  { code: "ms", label: "Malay", native: "Bahasa Melayu", flag: "🇲🇾" },
  { code: "ml", label: "Malayalam", native: "മലയാളം", flag: "🇮🇳" },
  { code: "mr", label: "Marathi", native: "मराठी", flag: "🇮🇳" },
  { code: "no", label: "Norwegian", native: "Norsk", flag: "🇳🇴" },
  { code: "pa", label: "Punjabi", native: "ਪੰਜਾਬੀ", flag: "🇮🇳" },
  { code: "ro", label: "Romanian", native: "Română", flag: "🇷🇴" },
  { code: "sr", label: "Serbian", native: "Српски", flag: "🇷🇸" },
  { code: "sk", label: "Slovak", native: "Slovenčina", flag: "🇸🇰" },
  { code: "sl", label: "Slovenian", native: "Slovenščina", flag: "🇸🇮" },
  { code: "sw", label: "Swahili", native: "Kiswahili", flag: "🇰🇪" },
  { code: "ta", label: "Tamil", native: "தமிழ்", flag: "🇮🇳" },
  { code: "te", label: "Telugu", native: "తెలుగు", flag: "🇮🇳" },
  { code: "cy", label: "Welsh", native: "Cymraeg", flag: "🏴󠁧󠁢󠁷󠁬󠁳󠁿" },
] as const;

export type LangCode = (typeof LANGUAGES)[number]["code"];

/** Languages Soniox TTS can speak: all of them. Kept as a set so a future gap is a one-line change. */
export const TTS_LANGS: ReadonlySet<string> = new Set(LANGUAGES.map((l) => l.code));

export function isTtsLang(code: string): boolean {
  return TTS_LANGS.has(code);
}

export function isLangCode(code: string): code is LangCode {
  return LANGUAGES.some((l) => l.code === code);
}

export function languageLabel(code: string): string {
  return LANGUAGES.find((l) => l.code === code)?.label ?? code;
}
